import { EnumDataType } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';

/** 校验工具类 */
export class ValidateHelper {
  /**
   * 校验值是否不为空，不为空则返回true，否则返回false
   * @param value 要校验的值
   * @returns 是否通过校验
   */
  public static IsNotNullOrEmpty(value: string) {
    if (value && value !== null && value !== '') {
      return true;
    }
    return false;
  }

  /**
   * 校验值是否不为空（不是undefined，也不等于null），不为空则返回true，否则返回false
   * @param value 要校验的值
   * @returns 是否通过校验
   */
  public static IsNotNullOrUndefined(value: any) {
    if (value && value !== null) {
      return true;
    }
    return false;
  }

  /**
   * 根据引用类型名称判断是否是枚举，要求枚举类型必须以Enum开头，不做类型是否真实存在的判断
   * @param dataType 数据类型
   * @param referenceType 引用类型名称或全名
   * @returns 是否是枚举类型
   */
  public static IsEnum(dataType: EnumDataType, referenceType: string) {
    if (dataType === EnumDataType.Reference && this.IsNotNullOrEmpty(referenceType)) {
      let typeName = referenceType;
      if (referenceType.indexOf('.') > -1) {
        const items = referenceType.split('.');
        typeName = items[items.length - 1];
      }
      if (typeName.toLowerCase().startsWith('enum')) {
        return true;
      }
    }
    return false;
  }

  /** 判断是否是有效的数字 */
  public static isNumber(value: string): boolean {
    const result = Number(value);
    if (isNaN(result)) {
      return false;
    }
    return true;
  }

  /**
   * 正则表达式验证
   * @param express 正则表达式
   * @param message 错误提示消息
   * @param value 校验的值
   * @param callback 回调方法，接收Error实例作为参数
   * @returns 回调
   */
  public static validateExpressWithCallback(express: string, message: string, value: string, callback: any) {
    const reg = new RegExp(express);
    if (value === '' || reg.test(value)) {
      return callback();
    }
    callback(new Error(message));
  }

  /**
   * 正则表达式验证
   * @param express 正则表达式
   * @param value 校验的值
   * @returns 是否成功
   */
  public static validateExpress(express: string, value: string) {
    const reg = new RegExp(express);
    return reg.test(value);
  }

  /** 判断首字母是否是大写 */
  public static validateFirstIsUpper(checkStr: string): boolean {
    if (checkStr.length > 0) {
      if (checkStr.charAt(0) === checkStr.charAt(0).toUpperCase()) {
        return true;
      }
    }
    return false;
  }

  /** 判断首字母是否是小写 */
  public static validateFirstIsLower(checkStr: string): boolean {
    if (checkStr.length > 0) {
      if (checkStr.charAt(0) === checkStr.charAt(0).toLowerCase()) {
        return true;
      }
    }
    return false;
  }
}
